import { API_PREFIX } from "@/constants"

import type { KnowledgeNode } from "./types"

export const isImageNode = (node: KnowledgeNode | null | undefined): boolean =>
  node?.node_type === "FILE" &&
  (node.content_type || "").toLowerCase().startsWith("image/")

export const getImageFormatLabel = (contentType?: string | null) => {
  const subtype = (contentType || "")
    .split(";", 1)[0]
    .split("/", 2)[1]
    ?.toLowerCase()

  if (!subtype) return null
  if (subtype === "jpeg") return "JPG"
  if (subtype === "svg+xml") return "SVG"
  return subtype.toUpperCase()
}

export const getImageSearchDescription = (
  content: string | null | undefined,
  fileName: string
) => {
  if (!content) return ""

  const lines = content.replace(/\r\n/g, "\n").split("\n")
  const firstLine = lines[0]?.trim() || ""
  if (
    firstLine.startsWith("# ") &&
    firstLine.slice(2).trim() === fileName.trim()
  ) {
    lines.shift()
    while (lines[0]?.trim() === "") lines.shift()
  }

  return lines
    .map((line) =>
      line
        .replace(/^#{1,6}\s+/, "")
        .replace(/^\s*[-*+]\s+/, "• ")
        .replace(/!\[([^\]]*)\]\([^)]+\)/g, "$1")
        .replace(/\[([^\]]+)\]\([^)]+\)/g, "$1")
        .replace(/(\*\*|__)(.*?)\1/g, "$2")
        .replace(/`([^`]+)`/g, "$1")
    )
    .join("\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim()
}

export const buildKnowledgeBaseNodeMediaUrl = ({
  serverRoot,
  organizationId,
  workspaceId,
  knowledgeBaseId,
  nodeId,
}: {
  serverRoot: string
  organizationId: string
  workspaceId: string
  knowledgeBaseId: string
  nodeId: string
}) => {
  const root = serverRoot.replace(/\/$/, "")
  return `${root}${API_PREFIX}/organizations/${encodeURIComponent(organizationId)}/workspaces/${encodeURIComponent(workspaceId)}/knowledge_bases/${encodeURIComponent(knowledgeBaseId)}/nodes/${encodeURIComponent(nodeId)}/media`
}
